import handle from "./Axios"

export type OrderType = {
  id: number
  from: string
  to: string
  token: string
  fiat: string
  status: string
  createdAt: string
  merchantName: string | null
  merchantId: number | null
}

const getList = ([url, params]: [string, string]) => {
  try {
    return handle.get(url + '?' + params).then(res => {
      const resData = res.data.data

      return {
        data: res.data.data.data.map(item => ({
          id: item.id,
          from: item.amount,
          to: item.total_vnd_after_fee,
          token: item.token_symbol,
          fiat: item.fiat_name,
          status: item.status.value,
          createdAt: item.created_at,
          merchantName: item.merchant_name,
          merchantId: item.merchant_id,
        })) as OrderType[],
        pagination: {
          pageSize: resData.per_page,
          total: resData.total,
          page: resData.current_page
        }
      }
    })
  } catch (error: any) {
    const { response, message } = error
    if (response) {
      return response
    }
    return message
  }
}

const getDetail = ([url, id]: [string, string]) => {
  try {
    return handle.get(url + '/' + id).then(res => {
      const resData = res.data.data
      return resData

      // return {
      //   data: res.data.data.data.map(item => ({
      //     id: item.id,
      //     from: item.amount,
      //     to: item.total_vnd_after_fee,
      //     token: item.token_symbol,
      //     fiat: item.fiat_name,
      //     status: item.status.value,
      //     createdAt: item.created_at
      //   })) as OrderType[],
      //   pagination: {
      //     pageSize: resData.per_page,
      //     total: resData.total,
      //     page: resData.current_page
      //   }
      // }
    })
  } catch (error: any) {
    const { response, message } = error
    if (response) {
      return response
    }
    return message
  }
}

export default { getList, getDetail }